import Marionette from "backbone.marionette";
import Radio from "backbone.radio";

const channel = Radio.channel("global");

class Title extends Marionette.Behavior {
  onBeforeShow() {
    if (this.view.model) {
      // trigger set title
      channel.trigger("set:title", this.view.model);
    }
  }
}

export { Title as default };
